module.exports = __webpack_public_path__ + "img/hxjz_bg.069cb265.png";